import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SURVEY_ANSWER_OPTIONS, AnswerOption } from '../../shared/constants/survey.constants';
import { environment } from '../../../environments/environment';
import { LinkConfirmationService } from '../../shared/services/link-confirmation.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
  standalone: false,
})
export class SurveyComponent {
  @Input() answer: string | null = null;
  @Input() conversationId: string | null = null;
  @Output() submitted = new EventEmitter<string>();
  @Output() skipped = new EventEmitter<void>();

  selectedOption: string | null = null;
  followUpDismissed = false;
  readonly options: AnswerOption[] = SURVEY_ANSWER_OPTIONS;
  readonly followUpUrl = environment.surveyFollowUpUrl;

  constructor(private linkConfirmationService: LinkConfirmationService) {}

  onOptionSelect(option: string): void {
    this.selectedOption = option;
  }

  onSubmit(): void {
    if (this.selectedOption) {
      this.submitted.emit(this.selectedOption);
    }
  }

  onSkip(): void {
    this.skipped.emit();
  }

  onFollowUpStart(): void {
    if (this.conversationId && this.followUpUrl) {
      this.linkConfirmationService.openLink(this.followUpUrl, this.conversationId);
    }
    this.followUpDismissed = true;
  }

  onFollowUpSkip(): void {
    this.followUpDismissed = true;
  }
}
